import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getPresentationProofsOptions,
  useDeletePresentationProof,
  useUploadOrUpdatePresentationProof,
} from './model/PresentationProofModel';

interface PresentationProofActionProps {
  presentationId: number;
  authors: Author[];
  variant?: 'compact';
}

export function PresentationProofAction({ presentationId, authors }: PresentationProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getPresentationProofsOptions(presentationId));
  const uploadOrUpdateMutation = useUploadOrUpdatePresentationProof(presentationId);
  const deleteMutation = useDeletePresentationProof(presentationId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="presentation"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
